import React, { useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import { useRouter, useGet } from '../../../components';
import { Item } from '../../items/item';
import { NotFound } from '../../../components';
import env from '../../../env';
import { useStore } from '../../../store';
import { ErrorPopup, Loading } from '../../../components';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import { useInstagram } from '../../../components';
import { MetaTag } from '../../../components';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import { gtm } from '../../../lib/tracking';
import { useAuth } from '../../../auth/index';
// import { useUsers } from '../../../components/customAuth/users/index';

const log = (...args) => {
  //console.log(args);
}
const areEqual = (prevProps, nextProps) => {
  return (prevProps.pageData === nextProps.pageData)
};
const PageMemo = React.memo(Page, areEqual)

// Generate breadcrumbs for protected routes
// function generateBreadcrumbs(pathname) {
//   const breadcrumb = {
//     items: [
//       { title: 'Home', link: '/' }
//     ]
//   };

//   // Add breadcrumbs for member routes
//   if (pathname.startsWith('/members/')) {
//     breadcrumb.items.push({ title: 'Members', link: '/members' });
    
//     // Add specific member type breadcrumbs
//     if (pathname.includes('/entered-apprentice')) {
//       breadcrumb.items.push({ title: 'Entered Apprentice', link: '/members/entered-apprentice' });
//     } else if (pathname.includes('/fellow-craft')) {
//       breadcrumb.items.push({ title: 'Fellow Craft', link: '/members/fellow-craft' });
//     } else if (pathname.includes('/master-mason')) {
//       breadcrumb.items.push({ title: 'Master Mason', link: '/members/master-mason' });
//     } else if (pathname.includes('/rose-croix')) {
//       breadcrumb.items.push({ title: 'Rose Croix', link: '/members/rose-croix' });
//     } else if (pathname.includes('/knights-kadosh')) {
//       breadcrumb.items.push({ title: 'Knights Kadosh', link: '/members/knights-kadosh' });
//     } else if (pathname.includes('/tribunal-of-courage')) {
//       breadcrumb.items.push({ title: 'Tribunal Of Courage', link: '/members/tribunal-of-courage' });
//     } else if (pathname.includes('/consistory')) {
//       breadcrumb.items.push({ title: 'Consistory', link: '/members/consistory' });
//     } else if (pathname.includes('/baringa-triangle')) {
//       breadcrumb.items.push({ title: 'Baringa Triangle', link: '/members/baringa-triangle' });
//     }
//   }

//   return breadcrumb;
// }

export function ViewPage() {
  const { dispatch } = useStore();
  const [pageLoaded, setPageLoaded] = useState(false);
  const [data, setData] = useState(null);
  //const path = usePath();
  //log('view page', path);
  const router = useRouter();
  const { pathname, Redirect } = useRouter();
  useInstagram();

  const get = useGet();
  log('0. viewpage ready');

  useEffect(() => {
    log('*. start loading')
    setPageLoaded(false);
    get.send(env.apiBase + "/api/cms/GetPublishedPage?path=" + pathname);
    // eslint-disable-next-line
  }, [pathname]);

  useEffect(() => {
    if (data){
      dispatch({ type: 'SET_PAGE', payload: data.data })
      dispatch({ type: 'SET_MENU', payload: data.menu })
    }
    // eslint-disable-next-line
  }, [data]);

  if (get.loading()) {
    return <Loading />
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  //log(router.pathname);
  //log(get.loading());
  log('1. viewpage component', pageLoaded, get.response);


  const pageData = get.response.data;
  //const menuData = get.response.menu;
  const redirectTo = get.response.redirectTo;

  const cmsOption = {};
  log(pageLoaded, !pageLoaded && !!pageData)
  if (!pageLoaded && pageData) {
    //log(pageLoaded, pageData, menuData)
    log('2. dispatching page & menu')
    setPageLoaded(true);
    setData(get.response);
    document.title = pageData.pageTitle;
    gtm.pageView(pathname, pageData.pageTitle);
    return null;
  } else if (redirectTo) {
    if (redirectTo.indexOf('http') >= 0 && typeof window !== `undefined`) {
      return window.location.href = redirectTo;
    } else {
      return <Redirect to={redirectTo} />
    }
  } else if (!pageLoaded && !pageData) {
    setPageLoaded(true);
    setData(get.response);
    return (<NotFound />)
  }

  log('3. call rendering memo')
  if (pageData)
  return <PageMemo pageData={pageData} cmsOption={cmsOption} pathname={pathname} />;
  else
    return <NotFound />
}


function Page(props) {
  const pageData = props.pageData;
  const cmsOption = props.cmsOption;
  const pathname = props.pathname;
  cmsOption.pageData = pageData;
  const _auth = useAuth();
  const [pageLoading, setPageLoading] = useState(true);
  const [checkAuthSession, setCheckAuthSession] = useState(0);
  const session = _auth.sessionV2 || _auth.session || _auth.user;

  // const users = useUsers();
  // document.title = pageData.pageTitle;
  log('4. page rendering', pageData, cmsOption)
  const sectionItems = pageData.sections.map((section, index) => {
    return (
      <Section item={section} key={section.sectionName + index} cmsOption={cmsOption}></Section>
    )
  }
  );

  const pageType = cmsUtils.payload(pageData, "PageType") || "public";  

  useEffect(()=> {
    if(pageType === "public"){
      setPageLoading(false);
      return;
    }
    else if(pageType === "member"){
      if(_auth.session && !_auth.session.expired()){
        setPageLoading(false);
      }
      else{
        if(checkAuthSession >= 2 ){
          setPageLoading(false);
          return;
        }
        setTimeout(() => {
          setCheckAuthSession(checkAuthSession + 1); 
        }, 1500);
      }
    }
    else if(pageType === "admin"){
      if(_auth.session && !_auth.session.expired()){
        setPageLoading(false);
      }
      else{
        if(checkAuthSession >= 2 ){
          setPageLoading(false);
          return;
        }
        setTimeout(() => {
          setCheckAuthSession(checkAuthSession + 1); 
        }, 1500);
      }
    }
  }, [_auth.session, checkAuthSession, pageType]);

  // Generate breadcrumbs for protected routes
  // const breadcrumb = generateBreadcrumbs(pathname);

  return (
    pageLoading ? <Loading /> 
    : (checkAuthSession === 2 ? (
        pageType === "admin"
          ? <Redirect to="/login/admin" />
          : <Redirect to="/members/login" />
      ) : 
      <>
      <MetaTag data={getMetaTag(pageData)} />
      <div className={`cmsPage cmsPage--${pageData.pageTypeCode}`}>
        {/* Add breadcrumbs for member routes */}
        {/* {pathname.startsWith('/members/') && (
          <div className="container">
            <Breadcrumb breadcrumb={breadcrumb} />
          </div>
        )} */}
        {sectionItems}
      </div>
    </>)
    // <>
    //   <MetaTag data={getMetaTag(pageData)} />
    //   <div className={`cmsPage cmsPage--${pageData.pageTypeCode}`}>
    //     {sectionItems}
    //   </div>
    // </>
  );
}

function Section(props) {
  log('5. section rendering')
  const item = props.item;
  //const sectionName = item.sectionName;
  const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};
  if (!subItems || subItems.length === 0)
    return (<></>);

  const subItemsElts = subItems.map((subItem, index) =>
    <Item item={subItem} key={subItem.itemId} cmsOption={cmsOption}></Item>
  );
  return (
    <>
      {subItemsElts}
    </>
  );
}

function getMetaTag(pageData) {
  //const country = utils.site.isNZ? 'New Zealand' : 'Australia'
  const country = "Australia";
  const siteName = env.siteName;
  const titleSuffix = env.titleSuffix;

  return {
    title: pageData.pageTitle + ' | ' + titleSuffix,
    description: cmsUtils.payload(pageData, 'Description'),
    keywords: cmsUtils.payload(pageData, 'Keyword'),
    heroImageUrl: utils.site.fullUrl(cmsUtils.payload(pageData, 'ImageUrl')),
    language: 'English',
    country: country,
    siteName: siteName,
    url: utils.site.fullUrl(pageData.pageUrl),
    //canonical: utils.site.resourcePath(pageData.pageUrl)
  }
}

